export default "__VITE_ASSET__DTIKUlXY__"